import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { TokenService } from '../../../../core/services/token.service';

@Component({
  selector: 'app-session-modal',
  templateUrl: './session-modal.component.html',
  styleUrls: ['./session-modal.component.scss']
})
export class SessionModalComponent implements OnInit {
  timeToExpire$: Observable<number>;
  units: any;
  constructor(
    private activeModal: NgbActiveModal,
    private tokenService: TokenService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.timeToExpire$ = this.tokenService.remainToExpire();
    this.translate.get('units').subscribe(units => (this.units = units));
  }

  closeModal(accept: boolean) {
    if (accept) {
      this.activeModal.close(accept);
    } else {
      this.activeModal.dismiss(0);
    }
  }

  getUnit(value: string) {
    return this.units[value];
  }
}
